import { Trans } from '@lingui/macro';
import { Calendar } from 'lucide-react';
import { Link, useMatch } from 'react-router-dom';

import { Button } from 'components/ui/button';
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from 'components/ui/card';

export default function CalendarLinks({ links, eventId }) {
    const isEventPage = useMatch('/event/:eventId');

    return (
        <Card className="mb-8 border-solid border-border shadow-none">
            <CardHeader>
                <CardTitle className="text-xl md:text-2xl text-center">
                    <Trans>Add this event to your calendar</Trans>
                </CardTitle>
            </CardHeader>
            <CardContent>
                <div className="flex flex-col gap-3 items-center">
                    <Button asChild>
                        <a
                            className="no-underline max-w-80 w-full"
                            href={links.google_calendar_url}
                            target="_blank"
                            rel="noreferrer"
                        >
                            <Calendar aria-hidden />
                            <Trans>Google Calendar</Trans>
                        </a>
                    </Button>
                    <Button asChild>
                        <a
                            className="no-underline max-w-80 w-full"
                            href={links.outlook_calendar_url}
                            target="_blank"
                            rel="noreferrer"
                        >
                            <Calendar aria-hidden />
                            <Trans>Outlook.com / Hotmail</Trans>
                        </a>
                    </Button>
                    <Button asChild>
                        <a
                            className="no-underline max-w-80 w-full"
                            href={links.office_calendar_url}
                            target="_blank"
                            rel="noreferrer"
                        >
                            <Calendar aria-hidden />
                            <Trans>Outlook - Work or school</Trans>
                        </a>
                    </Button>
                    <Button asChild>
                        <a className="no-underline max-w-80 w-full" href={links.calendar_url}>
                            <Calendar aria-hidden />
                            <Trans>Other Calendar</Trans>
                        </a>
                    </Button>
                </div>
            </CardContent>
            {!isEventPage && (
                <CardFooter className="justify-center">
                    <Link
                        to={`/event/${eventId}`}
                        className="inline-block text-sm text-primary underline-offset-4 hover:underline"
                    >
                        <Trans>Back to event</Trans>
                    </Link>
                </CardFooter>
            )}
        </Card>
    );
}
